module.exports = __webpack_public_path__ + "static/media/salary-on.e62ec9ee.svg";